import React from 'react';
import { Box, Tip, Text, CheckBox } from 'grommet';
import { CircleQuestion } from 'grommet-icons';

function BudgetOptimizationToggle({
  automatedBudgetOptimization,
  onChange,
  canEdit,
  capStrategy,
  dailyRevenueCap
}) {
  const isEligible = capStrategy === 'revenue' && dailyRevenueCap > 0;
  const isDisabled = !canEdit || !isEligible;

  return (
    <Box
      direction='row'
      gap='small'
      margin={{
        vertical: 'small'
      }}
    >
      <Text>
        Automated Budget Optimization:
        <Tip content='This optimization is only used when ML Sort Strategy performs the ad serve.'>
          <CircleQuestion
            color='grey'
            size='small'
            style={{ marginLeft: '3px' }}
          />
        </Tip>
      </Text>
      <CheckBox
        toggle
        disabled={isDisabled}
        checked={automatedBudgetOptimization || false}
        onChange={event => {
          onChange({ automatedBudgetOptimization: event.target.checked });
        }}
      />
    </Box>
  );
}

export default BudgetOptimizationToggle;
